<!-- 
  负责人 组件
  prop: 
    item: 绑定对象
    form: form表单数据对象
  emit:
    change: 选中后触发change事件
 -->

<template>
  <div>
    <div class="item-select">
      <span class="item" v-for="item in form[item.attr]">
        <span class="text">{{item.name}}</span>
        <i class="del el-icon-close" @click="del"></i>
      </span>
      <el-button type="text" class="select-btn" @click="showRemote=!showRemote">选择</el-button>
    </div>
    <!-- 远程搜索下拉框 -->
    <div class="remote-select" v-clickoutside="hide" v-if="showRemote">
      <div class="search">
        <input class="search-input" v-model="value" @keyup="handleSearch" placeholder="输入关键词进行搜索">
        </input>
        <i class="el-icon-search"></i>
      </div>
      <div class="scroll-con" v-loading="loading">
        <el-radio-group v-model="userId" class="list-con">
          <div class="item" v-for="item in listData" @change="saveObj(item)">
            <el-radio :label="item.userId">{{item.value}}</el-radio>
          </div>
        </el-radio-group>
        <div class="no-data" v-if="showNodata">
          暂无数据
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from 'src/api'
import Clickoutside from 'element-ui/lib/utils/clickoutside'
import { mapActions } from 'vuex'
let lazy

export default {
  props: ['item', 'form'],
  data () {
    return {
      value: '',
      userId: this.item.id || '',
      listData: [],
      showNodata: false,
      showRemote: false,
      loading: false
    }
  },
  methods: {
    ...mapActions([
      'setAttr'
    ]),
    // 删除
    del () {
      this.form[this.item.attr] = ''
      this.setAttr(this.item.attr)
      this.userId = ''
    },
    // 保存
    saveObj (item) {
      let arr = [
        {
          'name': item.value,
          'id': item.userId
        }
      ]
      this.value = ''
      this.form[this.item.attr] = arr
      this.setAttr(this.item.attr)
      this.$emit('change', arr)
      this.hide()
    },
    hide () {
      this.$nextTick(() => {
        this.showRemote = false
      })
    },
    getStaff (key) {
      let url = '/user/getStaffsAjax.html'
      let params = {
        nameLike: key || ''
      }
      api.post(url, params, (data) => {
        this.listData = data.result
      })
    },
    handleSearch (e) {
      let key = this.value.toString().trim()
      if (key || e.keyCode === 8) { // 手动删除搜素值的时候允许空字符串
        window.clearTimeout(lazy)
        lazy = window.setTimeout(() => { this.getStaff(key) }, 300)
      }
    }
  },

  watch: {
    showRemote (val) {
      if (val) {
        this.getStaff()
      }
    }
  },
  directives: { Clickoutside }
}
</script>

<style lang="less" scoped>
  @import '../../assets/less/remote-select.less';
</style>
<style lang="less">
  .remote-select {
    .el-radio {
      .el-radio__label {
        margin-left: 10px;
        width: 270px;
        display: inline-block;
        line-height: 36px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// manager.vue?5ba0f5a6